export const login_en = {
  login: {
    'title-section': {
      title: 'Sign In',
      description: 'Sign in with your Samsung Business Account',
    },
    form: {
      fields: {
        'login-id': {
          label: 'Login ID (e-mail)',
          placeholder: 'Enter your e-mail',
        },
        password: {
          label: 'Password',
          placeholder: 'Enter your password',
        },
        'forgot-password-link.title': 'Forgot Password?',
        button: {
          'sign-in': 'Sign In',
          'samsung-employee-sign-in': 'Samsung Employee Login',
        },
      },
    },
    errors: {
      'mfa-error-title': 'MFA Login Error',
      'mfa-error-description': 'MFA login failed. Please try again.',
      'pending-registration': 'Pending registration.',
      'change-password': "It's been 90 days since you changed your password.\nPlease change your password.",
      'required-captcha': 'To login, confirm you are not a robot.',
      'wrong-captcha': 'Wrong captcha.',
      'account-locked': 'This account has been locked.\nPlease contact the administrator.',
      'invalid-parameter-value': 'The account is not registered, or the ID or password information does not match.',
      'email-or-password-incorrect': 'Your email address or password is incorrect.\nPlease try again.',
      default: 'Invalid login request.\nPlease try to sign-in from the beginning.',
    },
  },
};
